import * as z from 'zod';
export const Permission = z.enum([
    'patients.edit',
    'prescriptions.edit',
    'prescriptions.validate_doctor',
    'prescriptions.validate_pharmacist',
    'prescriptions.approve_budget',
    'prescriptions.patient_arrival',
    'administration.administer',
    'production.access',
    'production.produce',
    'production.release',
    'stock.manage',
    'catalogue.view',
    'catalogue.manage',
    'basic_data.manage',
    'protocols.view',
    'protocols.manage',
    'organisation.manage',
    'interfaces.manage',
    'reports.view',
    'reports.identifiers',
    'users.manage',
    'settings.manage',
    'logs.view',
]);
export const GROUP_TYPE_PRESETS = {
    DOCTOR: [
        'patients.edit',
        'prescriptions.edit',
        'prescriptions.validate_doctor',
        'prescriptions.patient_arrival',
        'protocols.view',
        'protocols.manage',
    ],
    PHARMACIST: [
        'patients.edit',
        'prescriptions.edit',
        'prescriptions.validate_pharmacist',
        'production.access',
        'production.produce',
        'production.release',
        'stock.manage',
        'catalogue.view',
        'catalogue.manage',
        'basic_data.manage',
        'protocols.view',
        'interfaces.manage',
        'reports.view',
    ],
    TEHNICIAN: ['production.access', 'production.produce', 'stock.manage', 'catalogue.view'],
    NURSE: ['patients.edit', 'prescriptions.patient_arrival', 'administration.administer'],
    ADMIN: [
        'prescriptions.approve_budget',
        'production.access',
        'catalogue.view',
        'catalogue.manage',
        'basic_data.manage',
        'protocols.view',
        'protocols.manage',
        'organisation.manage',
        'interfaces.manage',
        'reports.view',
        'reports.identifiers',
        'users.manage',
        'settings.manage',
        'logs.view',
    ],
    OTHER: [],
};
const IMPLIED_PERMISSIONS = {
    'catalogue.manage': ['catalogue.view'],
    'protocols.manage': ['protocols.view'],
    'production.produce': ['production.access'],
    'production.release': ['production.access'],
};
/** The only place that turns a group into permissions. Phase 2 (CY-208) changes just this function. */
export function getGroupPermissions(group) {
    return group.type ? GROUP_TYPE_PRESETS[group.type] : [];
}
export function getUserPermissions(groups) {
    const permissions = new Set();
    for (const group of groups ?? []) {
        for (const permission of getGroupPermissions(group)) {
            permissions.add(permission);
            for (const implied of IMPLIED_PERMISSIONS[permission] ?? [])
                permissions.add(implied);
        }
    }
    return permissions;
}
export function hasPermission(groups, permission) {
    return getUserPermissions(groups).has(permission);
}
export function hasAnyPermission(groups, permissions) {
    const owned = getUserPermissions(groups);
    return permissions.some(permission => owned.has(permission));
}
export class ForbiddenError extends Error {
    permission;
    constructor(permission) {
        super(`Forbidden: missing permission ${permission}`);
        this.permission = permission;
        this.name = 'ForbiddenError';
    }
}
export function assertCan(ctx, permission) {
    assertIsAuthenticated(ctx);
    if (!hasPermission(ctx.groups, permission))
        throw new ForbiddenError(permission);
}
export function assertIsAuthenticated(ctx) {
    if (!ctx?.user?.id)
        throw new Error('Not authenticated');
}
//# sourceMappingURL=permissions.js.map